import { apiObjUrl, gatewayServices } from "src/common/apiUrl";
import { rest } from "src/common/rest";
import { zEntity } from "src/types/ZEntity";
import { ZUid } from "src/types/zUid";
import {
  zEntCopyDataAttr,
  ZEntCopyDataAttr,
  zEntCopyDataResp,
  ZEntCopyDataResp,
} from "./types";

export const loadChildAttributes = async (
  objId: ZUid,
  options: {
    translate?: boolean;
  } = {},
): Promise<ZEntCopyDataAttr[]> => {
  const { translate } = options;
  const res = await rest.get(apiObjUrl(`/objects/${objId}/child-attributes`), {
    translate,
  });
  return zEntCopyDataAttr.array().parse(res.data);
};

/**
 * Копировать теперь нужно не только атрибуты, но и бизнес-сервисы.
 * Загружаем из кэша.
 */
export const loadChildAttsAndBss = async (
  objectId: ZUid,
  options: {
    translate?: boolean;
  } = {},
): Promise<ZEntCopyDataResp> => {
  const { translate } = options;
  const res = await rest.get(
    apiObjUrl(`/objects/business-services-and-child-attributes`),
    { translate, params: { objectId } },
  );
  return zEntCopyDataResp.parse(res.data);
};

export const copyEntityAttributes = async (
  entityId: ZUid,
  childAtts?: ZUid[],
) =>
  rest
    .post(apiObjUrl("/entities/copy"), {
      entityId,
      attributes: childAtts,
    })
    .then((resp) => zEntity.parse(resp.data));

export const copyEntityBs = (
  sourceEntityId: ZUid,
  targetEntityId: ZUid,
  bsApiUrlBase: string,
) =>
  rest.put(gatewayServices(`${bsApiUrlBase}copy`), undefined, {
    params: { sourceEntityId, targetEntityId },
  });
